import angular from 'angular';

import CopyReportLinkModalController from './CopyReportLinkModalController';
import CopyReportLinkComponent from './CopyReportLinkComponent';

export default angular
  .module('petroCloud.base.copyReportLink', [])
  .controller('CopyReportLinkModalController', CopyReportLinkModalController)
  .component(CopyReportLinkComponent.name, CopyReportLinkComponent)
  .name;
